import CompanyShow from './CompanyShow.vue'
export {CompanyShow}
export default CompanyShow

